






























import { Component, Vue } from "vue-property-decorator";
import { getAuthorizationInfo } from "@/services/authorizations/authorizationService";
import { AuthorizationInfo } from "@/services/authorizations/types";
import moment from "moment";

@Component
export default class AuthorizationInfoModal extends Vue {
    authorizationInfo = {} as AuthorizationInfo;

    open(authorizationId: string) {
        getAuthorizationInfo(authorizationId).then(response => {
            this.authorizationInfo = response;
            this.$bvModal.show("modal-authorizationInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-authorizationInfo");
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }
}
